@if (isLoading()) {
  <div class="lading-indicator">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <router-outlet></router-outlet>
}
